import './workspaces.css';
import { Component, h, state, css, page, signal, Fragment } from 'pylevate-runtime';
import { getMe } from '../api.js';
import { Nav } from '../components/nav.js';
import { WorkspacesPage } from '../ui/workspaces.js';
export class Workspaces extends Component {
  constructor(...args) {
    super(...args);
    this._email = signal('');
    this._ws_state = signal('');
    this._ws_name = signal('');
    this._ready = signal(false);
  }
  get email() { return this._email.value; }
  set email(v) { this._email.value = v; }
  get ws_state() { return this._ws_state.value; }
  set ws_state(v) { this._ws_state.value = v; }
  get ws_name() { return this._ws_name.value; }
  set ws_name(v) { this._ws_name.value = v; }
  get ready() { return this._ready.value; }
  set ready(v) { this._ready.value = v; }
  async componentDidMount() {
    let me = await getMe();
    if (!__truthy(me['signed_in'])) {
      window.location.href = '/api/auth/login?next=/workspaces';
      return;
    }
    this._email.value = me['account']['email'];
    this._ready.value = true;
  }
  set_ws(s, name) {
    this._ws_state.value = s;
    this._ws_name.value = name || '';
  }
  render(props, state, context) {
    const children = props && props.children;
    return h('div', {className: 'page-eb0294'}, h(Fragment, null, h(Nav, {email: this._email.value, ws_state: this._ws_state.value, ws_name: this._ws_name.value}), (this._ready.value ? h(WorkspacesPage, {onWsState: (s, n) => this.set_ws(s, n)}) : null)));
  }
}
Workspaces = page({title: 'Workspaces — Uplevate', route: '/workspaces'})(Workspaces);
